<template>
    <div style="height: 100vh; width: 100vw; margin: 0; padding: 0; overflow: hidden;">
        <iframe src="https://udify.app/chatbot/hkJnAvSzgwmVO6m2" style="width: 100%; height: 100%; min-height: 700px"
            frameborder="0" allow="microphone">
        </iframe>
    </div>
</template>

<script>
    export default {
        name:"AiKefu",
        data : {
            
        }
    }
</script>

<style lang="scss" scoped>

</style>